import { useQuery } from '@tanstack/react-query';

import { listLineChannels } from 'api/line';
import { queryKeys } from 'constants/queryKeys';
import { lineStrings } from 'constants/strings';
import { useAuth } from 'contexts/AuthContext';
import { toErrorMessage } from 'hooks/utils';
import type { TLineChannelAccount } from 'types';

type UseLineChannelAccountsResult = {
  accounts: TLineChannelAccount[];
  loading: boolean;
  error: string | undefined;
};

export function useLineChannelAccounts(organizationId?: number): UseLineChannelAccountsResult {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: [queryKeys.LINE_CHANNEL_ACCOUNTS, user?.uid, organizationId],
    enabled: Boolean(user?.uid),
    queryFn: () => listLineChannels(organizationId),
    retry: false,
  });

  return {
    accounts: query.data ?? [],
    loading: Boolean(user?.uid) && query.isPending,
    error: query.error
      ? toErrorMessage(
          query.error,
          lineStrings.management.errors.loadAccountsFailed,
        )
      : undefined,
  };
}
